import { motion } from 'motion/react';

export function AnimatedFileSearch({ className }: { className?: string }) {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <motion.path
        d="M14 2v4a2 2 0 0 0 2 2h4"
        variants={{
          normal: { pathLength: 1 },
          hover: { 
            pathLength: [1, 0, 1],
            transition: { duration: 1.5, ease: "easeInOut", repeat: Infinity } 
          }
        }}
      />
      <motion.path
        d="M4.268 21a2 2 0 0 0 1.727 1H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3"
        variants={{
          normal: { pathLength: 1 },
          hover: { 
            pathLength: [1, 0.8, 1],
            transition: { duration: 1.5, ease: "easeInOut", repeat: Infinity } 
          }
        }}
      />
      <motion.path
        d="m9 18-1.5-1.5"
        variants={{
          normal: { pathLength: 1, x: 0, y: 0 },
          hover: { 
            pathLength: [1, 0, 1],
            x: [0, -1, 0],
            y: [0, 1, 0],
            transition: { duration: 1.5, ease: "easeInOut", repeat: Infinity } 
          }
        }}
      />
      <motion.circle
        cx="5"
        cy="14"
        r="3"
        variants={{
          normal: { scale: 1 },
          hover: { 
            scale: [1, 1.2, 1],
            transition: { duration: 1.5, ease: "easeInOut", repeat: Infinity } 
          }
        }}
      />
    </motion.svg>
  );
}
